export default __webpack_public_path__ + "static/media/icon-chevron.327c70da.svg";